import { TranslateFunc } from '@prisjakt/ui-translate/src/translate-func';
import { UserReviewSummary } from 'src/types';
import { ReviewFilterOption } from '../../types';

export function getOptions(
  t: TranslateFunc,
  userReviewsSummary: UserReviewSummary
): ReviewFilterOption[] {
  return [
    {
      value: 'ALL',
      title: t('reviews', 'rating.option-all'),
      distribution: userReviewsSummary.countTotal,
    },
    {
      value: 'EXCELLENT',
      title: t('reviews', 'rating.option-excellent'),
      distribution: userReviewsSummary.distribution?.[0],
    },
    {
      value: 'GOOD',
      title: t('reviews', 'rating.option-good'),
      distribution: userReviewsSummary.distribution?.[1],
    },
    {
      value: 'OK',
      title: t('reviews', 'rating.option-ok'),
      distribution: userReviewsSummary.distribution?.[2],
    },
    {
      value: 'BAD',
      title: t('reviews', 'rating.option-bad'),
      distribution: userReviewsSummary.distribution?.[3],
    },
    {
      value: 'TERRIBLE',
      title: t('reviews', 'rating.option-terrible'),
      distribution: userReviewsSummary.distribution?.[4],
    },
  ];
}
